export default "__VITE_ASSET__2iP8oOoH__"